import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: string; output: string; }
  Decimal: { input: string; output: string; }
  Upload: { input: any; output: any; }
};

/** The Booking Proposal Service Type Enum */
export enum BookingProposalServiceTypeEnum {
  /** FCL */
  Fcl = 'FCL',
  /** LCL */
  Lcl = 'LCL'
}

/** The Booking Proposal Status Enum */
export enum BookingProposalStatusEnum {
  /** Enviada */
  Submitted = 'SUBMITTED',
  /** Retirada */
  Withdrawn = 'WITHDRAWN'
}

/** The Booking Quotation status shown to the invited agents */
export enum BookingQuotationExternalStatusEnum {
  /** Cancelada */
  Canceled = 'CANCELED',
  /** Encerrada */
  Closed = 'CLOSED',
  /** Concluída */
  Completed = 'COMPLETED',
  /** Aberta */
  Open = 'OPEN'
}

/** The Cargo Attribute Enum */
export enum CargoAttributeEnum {
  /** Baterias de lítio */
  BatteryLithium = 'BATTERY_LITHIUM',
  /** Carga perigosa (IMO) */
  DangerousGoods = 'DANGEROUS_GOODS',
  /** Grau alimentício */
  FoodGrade = 'FOOD_GRADE',
  /** Frágil */
  Fragile = 'FRAGILE',
  /** Carga pesada */
  HeavyLift = 'HEAVY_LIFT',
  /** Alto valor */
  HighValue = 'HIGH_VALUE',
  /** Animais vivos */
  LiveAnimals = 'LIVE_ANIMALS',
  /** Superdimensionada */
  Oversized = 'OVERSIZED',
  /** Perecível */
  Perishable = 'PERISHABLE',
  /** Farmacêutica */
  Pharma = 'PHARMA',
  /** Refrigerada */
  Reefer = 'REEFER',
  /** Temperatura controlada */
  TemperatureControlled = 'TEMPERATURE_CONTROLLED'
}

export type DeclineBookingQuotationParams = {
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** The Document Type Enum */
export enum DocumentTypeEnum {
  /** Documentos Adicionais de Seguro */
  AdditionalInsuranceDocuments = 'ADDITIONAL_INSURANCE_DOCUMENTS',
  /** Certificado de Análise */
  AnalysisCertificate = 'ANALYSIS_CERTIFICATE',
  /** Documentos de Embarque Aprovados */
  ApprovedShippingDocuments = 'APPROVED_SHIPPING_DOCUMENTS',
  /** BL */
  BillOfLading = 'BILL_OF_LADING',
  /** Booking */
  Booking = 'BOOKING',
  /** Nota Fiscal (BR) */
  BrazilianInvoice = 'BRAZILIAN_INVOICE',
  /** Relatório Teste Carbendazim */
  CarbendazimTestReport = 'CARBENDAZIM_TEST_REPORT',
  /** Comprovante de Presença de Carga */
  CargoPresence = 'CARGO_PRESENCE',
  /** Ordem de Coleta */
  CollectOrder = 'COLLECT_ORDER',
  /** Nota Fiscal Comercial */
  CommercialInvoice = 'COMMERCIAL_INVOICE',
  /** Aviso de Chegada de Container */
  ContainerArrivalNotice = 'CONTAINER_ARRIVAL_NOTICE',
  /** Avarias Container */
  ContainerDamage = 'CONTAINER_DAMAGE',
  /** Comprovante Devolução Vazio */
  ContainerProofOfReturn = 'CONTAINER_PROOF_OF_RETURN',
  /** Carta de Correção */
  CorrectionLetter = 'CORRECTION_LETTER',
  /** Fechamento de Custos */
  CostClosing = 'COST_CLOSING',
  /** CRT */
  Crt = 'CRT',
  /** Declaração de Trânsito Aduaneiro (DTA) */
  CustomsTransitDeclaration = 'CUSTOMS_TRANSIT_DECLARATION',
  /** Solicitação de Mercadorias Perigosas */
  DangerousGoodsRequest = 'DANGEROUS_GOODS_REQUEST',
  /** Certificado de Data (Fabricação/Validade) */
  DateCertificate = 'DATE_CERTIFICATE',
  /** Nota de Débito */
  DebitNote = 'DEBIT_NOTE',
  /** Nota Fiscal Derivada (Filha) */
  DerivedChildInvoice = 'DERIVED_CHILD_INVOICE',
  /** Extrato de Retificação DI */
  DiRectificationStatement = 'DI_RECTIFICATION_STATEMENT',
  /** Draft BL */
  DraftBl = 'DRAFT_BL',
  /** Draft CO */
  DraftCo = 'DRAFT_CO',
  /** Laudo de Arqueação - RPA */
  DraughtReport = 'DRAUGHT_REPORT',
  /** Declaração de Exportação */
  ExportDeclaration = 'EXPORT_DECLARATION',
  /** Declaração Única de Exportação (DUE) */
  ExportDeclarationDue = 'EXPORT_DECLARATION_DUE',
  /** Contrato de Câmbio */
  ForeignExchangeContract = 'FOREIGN_EXCHANGE_CONTRACT',
  /** Cotação Frete */
  FreightQuote = 'FREIGHT_QUOTE',
  /** Comprovantes Frete */
  FreightReceipts = 'FREIGHT_RECEIPTS',
  /** Certificado de Fumigação */
  FumigationCertificate = 'FUMIGATION_CERTIFICATE',
  /** GRU Anvisa */
  GruAnvisa = 'GRU_ANVISA',
  /** HAWB */
  Hawb = 'HAWB',
  /** Certificado de saúde */
  HealthCertificate = 'HEALTH_CERTIFICATE',
  /** Guia ICMS */
  Icms = 'ICMS',
  /** Declaração de Importação */
  ImportDeclaration = 'IMPORT_DECLARATION',
  /** Declaração de Importação (DI) */
  ImportDeclarationDi = 'IMPORT_DECLARATION_DI',
  /** Declaração Única de Importação (DUIMP) */
  ImportDeclarationDuimp = 'IMPORT_DECLARATION_DUIMP',
  /** Licença de Importação */
  ImportLicense = 'IMPORT_LICENSE',
  /** Licença de Importação (LI) */
  ImportLicenseLi = 'IMPORT_LICENSE_LI',
  /** Certificado de Inspeção */
  InspectionCertificate = 'INSPECTION_CERTIFICATE',
  /** Apólice de Seguro */
  InsurancePolicy = 'INSURANCE_POLICY',
  /** Nota Fiscal */
  Invoice = 'INVOICE',
  /** ISF-5 */
  Isf_5 = 'ISF_5',
  /** ISF-10 */
  Isf_10 = 'ISF_10',
  /** Relatório de Análise Laboratorial */
  LabAnalysisReport = 'LAB_ANALYSIS_REPORT',
  /** LPCO */
  Lpco = 'LPCO',
  /** Liberação MAPA */
  MapaApproval = 'MAPA_APPROVAL',
  /** MDFe */
  Mdfe = 'MDFE',
  /** Comprovante Marinha Mercante */
  MerchantMarineDocument = 'MERCHANT_MARINE_DOCUMENT',
  /** MIC */
  Mic = 'MIC',
  /** Confirmação do Pedido */
  OrderConfirmation = 'ORDER_CONFIRMATION',
  /** Certificado de Origem */
  OriginCertificate = 'ORIGIN_CERTIFICATE',
  /** Outro */
  Other = 'OTHER',
  /** Packing List */
  PackingList = 'PACKING_LIST',
  /** Certificado Fitossanitário */
  PhytosanitaryCertificate = 'PHYTOSANITARY_CERTIFICATE',
  /** Proforma Invoice */
  ProformaInvoice = 'PROFORMA_INVOICE',
  /** Comprovante de Entrega */
  ProofOfDelivery = 'PROOF_OF_DELIVERY',
  /** Comprovante de Importação */
  ProofOfImport = 'PROOF_OF_IMPORT',
  /** Comprovante de Pagamento (Swift/ABA) */
  ProofOfPayment = 'PROOF_OF_PAYMENT',
  /** Pedido de Compra */
  PurchaseOrder = 'PURCHASE_ORDER',
  /** Certificado de Qualidade */
  QualityCertificate = 'QUALITY_CERTIFICATE',
  /** Contrato de Venda */
  SalesContract = 'SALES_CONTRACT',
  /** Pedido de Venda */
  SalesOrder = 'SALES_ORDER',
  /** Certificado Sanitário */
  SanitaryCertificate = 'SANITARY_CERTIFICATE',
  /** Conhecimento de Embarque */
  ShipmentDocument = 'SHIPMENT_DOCUMENT',
  /** Pré-Alerta de Embarque */
  ShipmentPreAlert = 'SHIPMENT_PRE_ALERT',
  /** Conselho de Envio */
  ShippingAdvice = 'SHIPPING_ADVICE',
  /** Documentos de Embarque para Aprovação */
  ShippingDocumentsForApproval = 'SHIPPING_DOCUMENTS_FOR_APPROVAL',
  /** Instruções de Transporte */
  ShippingInstructions = 'SHIPPING_INSTRUCTIONS',
  /** Plano de Estufagem */
  StuffingPlan = 'STUFFING_PLAN',
  /** Etiqueta */
  Tag = 'TAG',
  /** CTE */
  TransportAcknowledgment = 'TRANSPORT_ACKNOWLEDGMENT',
  /** Certificado Veterinário */
  VeterinaryCertificate = 'VETERINARY_CERTIFICATE',
  /** Certificado Peso e Qualidade */
  WeightAndQualityCertificate = 'WEIGHT_AND_QUALITY_CERTIFICATE',
  /** Certificado de Peso */
  WeightCertificate = 'WEIGHT_CERTIFICATE',
  /** Declaração Embalagem Madeira */
  WoodPackagingDeclaration = 'WOOD_PACKAGING_DECLARATION'
}

/** A proposal sent by the invited agent */
export type ExternalBookingProposal = {
  __typename?: 'ExternalBookingProposal';
  attachments: Array<ExternalBookingProposalAttachment>;
  coLoader: Maybe<Scalars['String']['output']>;
  conditions: Maybe<Scalars['String']['output']>;
  destinationCosts: Maybe<Scalars['Decimal']['output']>;
  destinationInlandFreight: Maybe<Scalars['Decimal']['output']>;
  dischargePort: Maybe<ExternalMaritimePort>;
  id: Scalars['Int']['output'];
  insertedAt: Scalars['DateTime']['output'];
  internationalFreight: Maybe<Scalars['Decimal']['output']>;
  loadingPort: Maybe<ExternalMaritimePort>;
  number: Scalars['String']['output'];
  originCosts: Maybe<Scalars['Decimal']['output']>;
  originDomesticFreight: Maybe<Scalars['Decimal']['output']>;
  originFees: Maybe<Scalars['Decimal']['output']>;
  routeNotes: Maybe<Scalars['String']['output']>;
  sealine: Maybe<ExternalSealine>;
  serviceType: Maybe<BookingProposalServiceTypeEnum>;
  status: BookingProposalStatusEnum;
  total: Maybe<Scalars['Decimal']['output']>;
  transitTimeDays: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  withdrawnAt: Maybe<Scalars['DateTime']['output']>;
};

/** A file attached to a proposal by the invited agent */
export type ExternalBookingProposalAttachment = {
  __typename?: 'ExternalBookingProposalAttachment';
  downloadUrl: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  originalFilename: Maybe<Scalars['String']['output']>;
};

/** A Booking Quotation as seen by an invited agent */
export type ExternalBookingQuotation = {
  __typename?: 'ExternalBookingQuotation';
  agentNotes: Maybe<Scalars['String']['output']>;
  closesAt: Maybe<Scalars['DateTime']['output']>;
  collectionNotes: Maybe<Scalars['String']['output']>;
  declineReason: Maybe<Scalars['String']['output']>;
  declined: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  invitedAgent: ExternalInvitedAgent;
  owner: ExternalBookingQuotationOwner;
  proposals: Array<ExternalBookingProposal>;
  reference: Maybe<Scalars['String']['output']>;
  shipment: ExternalShipment;
  status: BookingQuotationExternalStatusEnum;
  timezone: Scalars['String']['output'];
  winnerProposalNumber: Maybe<Scalars['String']['output']>;
};

/** The company that requested the Booking Quotation */
export type ExternalBookingQuotationOwner = {
  __typename?: 'ExternalBookingQuotationOwner';
  logoUrl: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

/** A Process document shared through an external Invite */
export type ExternalDocument = {
  __typename?: 'ExternalDocument';
  downloadUrl: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  originalFilename: Maybe<Scalars['String']['output']>;
  type: Maybe<DocumentTypeEnum>;
};

/** The foreign trade shipment of a Process seen through an external Invite */
export type ExternalForeignTradeShipment = {
  __typename?: 'ExternalForeignTradeShipment';
  internationalFreight: Maybe<ExternalInternationalFreight>;
  maritimeTransportShipment: Maybe<ExternalMaritimeTransportShipment>;
  pallets: Array<ExternalShipmentPallet>;
  totalGrossWeight: Maybe<Scalars['Decimal']['output']>;
  totalNetWeight: Maybe<Scalars['Decimal']['output']>;
  totalPallets: Scalars['Int']['output'];
  type: Maybe<ShipmentTypeEnum>;
};

/** The international freight of a Process seen through an external Invite */
export type ExternalInternationalFreight = {
  __typename?: 'ExternalInternationalFreight';
  bookingDischargePort: Maybe<ExternalMaritimePort>;
  bookingEta: Maybe<Scalars['DateTime']['output']>;
  bookingEtd: Maybe<Scalars['DateTime']['output']>;
  bookingLoadingPort: Maybe<ExternalMaritimePort>;
  cargoAttributes: Array<CargoAttributeEnum>;
  expectedSeparationAt: Maybe<Scalars['DateTime']['output']>;
  pickupLocation: Maybe<Scalars['String']['output']>;
  sealine: Maybe<ExternalSealine>;
  vessel: Maybe<ExternalVessel>;
  voyageNumber: Maybe<Scalars['String']['output']>;
};

/** The freight agent the Booking Quotation invite was sent to */
export type ExternalInvitedAgent = {
  __typename?: 'ExternalInvitedAgent';
  name: Scalars['String']['output'];
};

/** A maritime port */
export type ExternalMaritimePort = {
  __typename?: 'ExternalMaritimePort';
  id: Scalars['Int']['output'];
  name: Maybe<Scalars['String']['output']>;
  unlocode: Maybe<Scalars['String']['output']>;
};

/** The maritime transport of a Process seen through an external Invite */
export type ExternalMaritimeTransportShipment = {
  __typename?: 'ExternalMaritimeTransportShipment';
  booking: Maybe<Scalars['String']['output']>;
};

/** An external Invite's publication status */
export enum ExternalPagePublicationStatusEnum {
  /** Cancelada */
  Canceled = 'CANCELED',
  /** Fechada */
  Closed = 'CLOSED',
  /** Rascunho */
  Draft = 'DRAFT',
  /** Aberta */
  Open = 'OPEN'
}

/** The kind of External Page */
export enum ExternalPageTypeEnum {
  /** Dados do Booking */
  BookingData = 'BOOKING_DATA',
  /** Cotação de Booking */
  BookingQuotation = 'BOOKING_QUOTATION'
}

/** A Process seen through an external Invite */
export type ExternalProcess = {
  __typename?: 'ExternalProcess';
  bookingQuotation: Maybe<ExternalBookingQuotation>;
  documents: Array<ExternalDocument>;
  foreignTradeShipment: Maybe<ExternalForeignTradeShipment>;
  id: Scalars['Int']['output'];
  owner: ExternalBookingQuotationOwner;
  referenceCode: Maybe<Scalars['String']['output']>;
  timezone: Scalars['String']['output'];
};

/** A sealine */
export type ExternalSealine = {
  __typename?: 'ExternalSealine';
  id: Scalars['Int']['output'];
  name: Maybe<Scalars['String']['output']>;
  nickname: Maybe<Scalars['String']['output']>;
};

/** The shipment data sent to the agents with the Booking Quotation */
export type ExternalShipment = {
  __typename?: 'ExternalShipment';
  cargoAttributes: Array<CargoAttributeEnum>;
  dischargePort: Maybe<ExternalMaritimePort>;
  documents: Array<ExternalDocument>;
  expectedSeparationAt: Maybe<Scalars['DateTime']['output']>;
  invoicesFinalValue: Maybe<Scalars['Decimal']['output']>;
  loadingPort: Maybe<ExternalMaritimePort>;
  maritimeTransportType: Maybe<MaritimeTransportTypeEnum>;
  pallets: Array<ExternalShipmentPallet>;
  pickupLocation: Maybe<Scalars['String']['output']>;
  shipmentType: Maybe<ShipmentTypeEnum>;
  totalGrossWeight: Maybe<Scalars['Decimal']['output']>;
  totalNetWeight: Maybe<Scalars['Decimal']['output']>;
  totalPallets: Scalars['Int']['output'];
};

/** A shipment pallet row shared with the invited agents */
export type ExternalShipmentPallet = {
  __typename?: 'ExternalShipmentPallet';
  eurCode: Maybe<Scalars['String']['output']>;
  heightCm: Maybe<Scalars['Int']['output']>;
  isoCode: Maybe<Scalars['String']['output']>;
  lengthMm: Maybe<Scalars['Int']['output']>;
  quantity: Scalars['Int']['output'];
  sizeType: PalletSizeTypeEnum;
  widthMm: Maybe<Scalars['Int']['output']>;
};

/** A vessel */
export type ExternalVessel = {
  __typename?: 'ExternalVessel';
  id: Scalars['Int']['output'];
  imoNumber: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

/** The public state of an external Invite */
export type Invite = {
  __typename?: 'Invite';
  canceledAt: Maybe<Scalars['DateTime']['output']>;
  closesAt: Maybe<Scalars['DateTime']['output']>;
  email: Maybe<Scalars['String']['output']>;
  locale: Maybe<LanguageEnum>;
  sessionValid: Maybe<Scalars['Boolean']['output']>;
  status: Maybe<ExternalPagePublicationStatusEnum>;
  type: Maybe<ExternalPageTypeEnum>;
};

/** The Language Enum */
export enum LanguageEnum {
  /** English (US) */
  EnUs = 'EN_US',
  /** Spanish (ES) */
  EsEs = 'ES_ES',
  /** Portuguese (BR) */
  PtBr = 'PT_BR'
}

/** The Maritime Transport Enum */
export enum MaritimeTransportTypeEnum {
  /** BREAKBULK */
  Breakbulk = 'BREAKBULK',
  /** BULK_CARGO */
  BulkCargo = 'BULK_CARGO',
  /** FCL */
  Fcl = 'FCL',
  /** LCL */
  Lcl = 'LCL'
}

/** The Pallet Size Type Enum */
export enum PalletSizeTypeEnum {
  /** Personalizado */
  Custom = 'CUSTOM',
  /** Não informado */
  NotInformed = 'NOT_INFORMED',
  /** Padrão */
  Standard = 'STANDARD'
}

export type RootMutationType = {
  __typename?: 'RootMutationType';
  /** Decline a booking quotation of the external Invite's recipient */
  declineBookingQuotation: Maybe<ExternalBookingQuotation>;
  /** Requests a new OTP code for the given invite */
  requestOtp: Maybe<Scalars['Boolean']['output']>;
  /** Sends the booking data of the external Invite's Process */
  submitBookingData: Maybe<ExternalProcess>;
  /** Upsert a proposal of the external Invite's recipient */
  upsertBookingProposal: Maybe<ExternalBookingProposal>;
  /** Validates the OTP code and sets the session cookie */
  validateOtp: Maybe<Scalars['Boolean']['output']>;
  /** Withdraw a proposal of the external Invite's recipient */
  withdrawBookingProposal: Maybe<ExternalBookingProposal>;
};


export type RootMutationTypeDeclineBookingQuotationArgs = {
  params?: InputMaybe<DeclineBookingQuotationParams>;
  token: Scalars['String']['input'];
};


export type RootMutationTypeRequestOtpArgs = {
  token: Scalars['String']['input'];
};


export type RootMutationTypeSubmitBookingDataArgs = {
  params: SubmitBookingDataParams;
  token: Scalars['String']['input'];
};


export type RootMutationTypeUpsertBookingProposalArgs = {
  params: UpsertBookingProposalParams;
  token: Scalars['String']['input'];
};


export type RootMutationTypeValidateOtpArgs = {
  code: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type RootMutationTypeWithdrawBookingProposalArgs = {
  id: Scalars['Int']['input'];
  token: Scalars['String']['input'];
};

export type RootQueryType = {
  __typename?: 'RootQueryType';
  /** Gets the Booking Quotation of an external Invite, for the agent's page */
  bookingQuotation: Maybe<ExternalBookingQuotation>;
  /** Search maritime ports for an external Invite's page */
  externalMaritimePorts: Array<ExternalMaritimePort>;
  /** Gets the Process of an external Invite's publication */
  externalProcess: Maybe<ExternalProcess>;
  /** Search sealines for an external Invite's page */
  externalSealines: Array<ExternalSealine>;
  /** Search vessels for an external Invite's page */
  externalVessels: Array<ExternalVessel>;
  /** Gets an external Invite from its link token */
  invite: Maybe<Invite>;
};


export type RootQueryTypeBookingQuotationArgs = {
  token: Scalars['String']['input'];
};


export type RootQueryTypeExternalMaritimePortsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeExternalProcessArgs = {
  token: Scalars['String']['input'];
};


export type RootQueryTypeExternalSealinesArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeExternalVesselsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeInviteArgs = {
  token: Scalars['String']['input'];
};

/** The Shipment Type Enum */
export enum ShipmentTypeEnum {
  /** Embarque de transporte Aéreo */
  AirTransport = 'AIR_TRANSPORT',
  /** Embarque de transporte Marítimo */
  MaritimeTransport = 'MARITIME_TRANSPORT',
  /** Embarque de transporte Rodoviário */
  RoadTransport = 'ROAD_TRANSPORT'
}

export type SubmitBookingDataParams = {
  booking: Scalars['String']['input'];
  bookingDischargePortId: Scalars['Int']['input'];
  bookingEta: Scalars['DateTime']['input'];
  bookingEtd: Scalars['DateTime']['input'];
  bookingLoadingPortId: Scalars['Int']['input'];
  document: Scalars['Upload']['input'];
  sealineId: Scalars['Int']['input'];
  vesselId: Scalars['Int']['input'];
  voyageNumber: Scalars['String']['input'];
};

export type UpsertBookingProposalAttachmentParams = {
  file?: InputMaybe<Scalars['Upload']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertBookingProposalParams = {
  attachments?: InputMaybe<Array<UpsertBookingProposalAttachmentParams>>;
  coLoader?: InputMaybe<Scalars['String']['input']>;
  conditions?: InputMaybe<Scalars['String']['input']>;
  destinationCosts?: InputMaybe<Scalars['Decimal']['input']>;
  destinationInlandFreight?: InputMaybe<Scalars['Decimal']['input']>;
  dischargePortId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  internationalFreight?: InputMaybe<Scalars['Decimal']['input']>;
  loadingPortId?: InputMaybe<Scalars['Int']['input']>;
  originCosts?: InputMaybe<Scalars['Decimal']['input']>;
  originDomesticFreight?: InputMaybe<Scalars['Decimal']['input']>;
  originFees?: InputMaybe<Scalars['Decimal']['input']>;
  routeNotes?: InputMaybe<Scalars['String']['input']>;
  sealineId?: InputMaybe<Scalars['Int']['input']>;
  serviceType?: InputMaybe<BookingProposalServiceTypeEnum>;
  transitTimeDays?: InputMaybe<Scalars['Int']['input']>;
};

export type InviteQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type InviteQuery = { __typename?: 'RootQueryType', invite: { __typename?: 'Invite', status: ExternalPagePublicationStatusEnum | null, type: ExternalPageTypeEnum | null, email: string | null, locale: LanguageEnum | null, closesAt: string | null, canceledAt: string | null, sessionValid: boolean | null } | null };

export type RequestOtpMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type RequestOtpMutation = { __typename?: 'RootMutationType', requestOtp: boolean | null };

export type ValidateOtpMutationVariables = Exact<{
  token: Scalars['String']['input'];
  code: Scalars['String']['input'];
}>;


export type ValidateOtpMutation = { __typename?: 'RootMutationType', validateOtp: boolean | null };

export type GetExternalMaritimePortsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetExternalMaritimePortsQuery = { __typename?: 'RootQueryType', externalMaritimePorts: Array<{ __typename?: 'ExternalMaritimePort', id: number, name: string | null, unlocode: string | null }> };

export type GetExternalSealinesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetExternalSealinesQuery = { __typename?: 'RootQueryType', externalSealines: Array<{ __typename?: 'ExternalSealine', id: number, name: string | null, nickname: string | null }> };

export type GetExternalVesselsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetExternalVesselsQuery = { __typename?: 'RootQueryType', externalVessels: Array<{ __typename?: 'ExternalVessel', id: number, name: string | null, imoNumber: string | null }> };

export type ExternalForeignTradeShipmentFieldsFragment = { __typename?: 'ExternalForeignTradeShipment', type: ShipmentTypeEnum | null, totalGrossWeight: string | null, totalNetWeight: string | null, totalPallets: number, pallets: Array<{ __typename?: 'ExternalShipmentPallet', sizeType: PalletSizeTypeEnum, lengthMm: number | null, widthMm: number | null, isoCode: string | null, eurCode: string | null, quantity: number, heightCm: number | null }>, maritimeTransportShipment: { __typename?: 'ExternalMaritimeTransportShipment', booking: string | null } | null, internationalFreight: { __typename?: 'ExternalInternationalFreight', cargoAttributes: Array<CargoAttributeEnum>, pickupLocation: string | null, expectedSeparationAt: string | null, voyageNumber: string | null, bookingEtd: string | null, bookingEta: string | null, sealine: { __typename?: 'ExternalSealine', id: number, name: string | null, nickname: string | null } | null, vessel: { __typename?: 'ExternalVessel', id: number, name: string | null, imoNumber: string | null } | null, bookingLoadingPort: { __typename?: 'ExternalMaritimePort', id: number, name: string | null, unlocode: string | null } | null, bookingDischargePort: { __typename?: 'ExternalMaritimePort', id: number, name: string | null, unlocode: string | null } | null } | null };

export type ExternalInternationalFreightFieldsFragment = { __typename?: 'ExternalInternationalFreight', cargoAttributes: Array<CargoAttributeEnum>, pickupLocation: string | null, expectedSeparationAt: string | null, voyageNumber: string | null, bookingEtd: string | null, bookingEta: string | null, sealine: { __typename?: 'ExternalSealine', id: number, name: string | null, nickname: string | null } | null, vessel: { __typename?: 'ExternalVessel', id: number, name: string | null, imoNumber: string | null } | null, bookingLoadingPort: { __typename?: 'ExternalMaritimePort', id: number, name: string | null, unlocode: string | null } | null, bookingDischargePort: { __typename?: 'ExternalMaritimePort', id: number, name: string | null, unlocode: string | null } | null };

export type ExternalMaritimeTransportShipmentFieldsFragment = { __typename?: 'ExternalMaritimeTransportShipment', booking: string | null };

export type ExternalProcessFieldsFragment = { __typename?: 'ExternalProcess', id: number, referenceCode: string | null, timezone: string, owner: { __typename?: 'ExternalBookingQuotationOwner', name: string, logoUrl: string | null }, documents: Array<{ __typename?: 'ExternalDocument', id: number, type: DocumentTypeEnum | null, originalFilename: string | null, downloadUrl: string | null }>, bookingQuotation: { __typename?: 'ExternalBookingQuotation', id: number, agentNotes: string | null, collectionNotes: string | null, winnerProposalNumber: string | null, invitedAgent: { __typename?: 'ExternalInvitedAgent', name: string } } | null, foreignTradeShipment: { __typename?: 'ExternalForeignTradeShipment', type: ShipmentTypeEnum | null, totalGrossWeight: string | null, totalNetWeight: string | null, totalPallets: number, pallets: Array<{ __typename?: 'ExternalShipmentPallet', sizeType: PalletSizeTypeEnum, lengthMm: number | null, widthMm: number | null, isoCode: string | null, eurCode: string | null, quantity: number, heightCm: number | null }>, maritimeTransportShipment: { __typename?: 'ExternalMaritimeTransportShipment', booking: string | null } | null, internationalFreight: { __typename?: 'ExternalInternationalFreight', cargoAttributes: Array<CargoAttributeEnum>, pickupLocation: string | null, expectedSeparationAt: string | null, voyageNumber: string | null, bookingEtd: string | null, bookingEta: string | null, sealine: { __typename?: 'ExternalSealine', id: number, name: string | null, nickname: string | null } | null, vessel: { __typename?: 'ExternalVessel', id: number, name: string | null, imoNumber: string | null } | null, bookingLoadingPort: { __typename?: 'ExternalMaritimePort', id: number, name: string | null, unlocode: string | null } | null, bookingDischargePort: { __typename?: 'ExternalMaritimePort', id: number, name: string | null, unlocode: string | null } | null } | null } | null };

export type GetExternalProcessQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type GetExternalProcessQuery = { __typename?: 'RootQueryType', externalProcess: { __typename?: 'ExternalProcess', id: number, referenceCode: string | null, timezone: string, owner: { __typename?: 'ExternalBookingQuotationOwner', name: string, logoUrl: string | null }, documents: Array<{ __typename?: 'ExternalDocument', id: number, type: DocumentTypeEnum | null, originalFilename: string | null, downloadUrl: string | null }>, bookingQuotation: { __typename?: 'ExternalBookingQuotation', id: number, agentNotes: string | null, collectionNotes: string | null, winnerProposalNumber: string | null, invitedAgent: { __typename?: 'ExternalInvitedAgent', name: string } } | null, foreignTradeShipment: { __typename?: 'ExternalForeignTradeShipment', type: ShipmentTypeEnum | null, totalGrossWeight: string | null, totalNetWeight: string | null, totalPallets: number, pallets: Array<{ __typename?: 'ExternalShipmentPallet', sizeType: PalletSizeTypeEnum, lengthMm: number | null, widthMm: number | null, isoCode: string | null, eurCode: string | null, quantity: number, heightCm: number | null }>, maritimeTransportShipment: { __typename?: 'ExternalMaritimeTransportShipment', booking: string | null } | null, internationalFreight: { __typename?: 'ExternalInternationalFreight', cargoAttributes: Array<CargoAttributeEnum>, pickupLocation: string | null, expectedSeparationAt: string | null, voyageNumber: string | null, bookingEtd: string | null, bookingEta: string | null, sealine: { __typename?: 'ExternalSealine', id: number, name: string | null, nickname: string | null } | null, vessel: { __typename?: 'ExternalVessel', id: number, name: string | null, imoNumber: string | null } | null, bookingLoadingPort: { __typename?: 'ExternalMaritimePort', id: number, name: string | null, unlocode: string | null } | null, bookingDischargePort: { __typename?: 'ExternalMaritimePort', id: number, name: string | null, unlocode: string | null } | null } | null } | null } | null };

export type SubmitBookingDataMutationVariables = Exact<{
  token: Scalars['String']['input'];
  params: SubmitBookingDataParams;
}>;


export type SubmitBookingDataMutation = { __typename?: 'RootMutationType', submitBookingData: { __typename?: 'ExternalProcess', id: number, referenceCode: string | null, timezone: string, owner: { __typename?: 'ExternalBookingQuotationOwner', name: string, logoUrl: string | null }, documents: Array<{ __typename?: 'ExternalDocument', id: number, type: DocumentTypeEnum | null, originalFilename: string | null, downloadUrl: string | null }>, bookingQuotation: { __typename?: 'ExternalBookingQuotation', id: number, agentNotes: string | null, collectionNotes: string | null, winnerProposalNumber: string | null, invitedAgent: { __typename?: 'ExternalInvitedAgent', name: string } } | null, foreignTradeShipment: { __typename?: 'ExternalForeignTradeShipment', type: ShipmentTypeEnum | null, totalGrossWeight: string | null, totalNetWeight: string | null, totalPallets: number, pallets: Array<{ __typename?: 'ExternalShipmentPallet', sizeType: PalletSizeTypeEnum, lengthMm: number | null, widthMm: number | null, isoCode: string | null, eurCode: string | null, quantity: number, heightCm: number | null }>, maritimeTransportShipment: { __typename?: 'ExternalMaritimeTransportShipment', booking: string | null } | null, internationalFreight: { __typename?: 'ExternalInternationalFreight', cargoAttributes: Array<CargoAttributeEnum>, pickupLocation: string | null, expectedSeparationAt: string | null, voyageNumber: string | null, bookingEtd: string | null, bookingEta: string | null, sealine: { __typename?: 'ExternalSealine', id: number, name: string | null, nickname: string | null } | null, vessel: { __typename?: 'ExternalVessel', id: number, name: string | null, imoNumber: string | null } | null, bookingLoadingPort: { __typename?: 'ExternalMaritimePort', id: number, name: string | null, unlocode: string | null } | null, bookingDischargePort: { __typename?: 'ExternalMaritimePort', id: number, name: string | null, unlocode: string | null } | null } | null } | null } | null };

export type ExternalBookingProposalFieldsFragment = { __typename?: 'ExternalBookingProposal', id: number, number: string, status: BookingProposalStatusEnum, serviceType: BookingProposalServiceTypeEnum | null, transitTimeDays: number | null, coLoader: string | null, routeNotes: string | null, originCosts: string | null, originFees: string | null, originDomesticFreight: string | null, internationalFreight: string | null, destinationCosts: string | null, destinationInlandFreight: string | null, total: string | null, conditions: string | null, withdrawnAt: string | null, insertedAt: string, updatedAt: string, sealine: { __typename?: 'ExternalSealine', id: number, name: string | null, nickname: string | null } | null, loadingPort: { __typename?: 'ExternalMaritimePort', id: number, name: string | null, unlocode: string | null } | null, dischargePort: { __typename?: 'ExternalMaritimePort', id: number, name: string | null, unlocode: string | null } | null, attachments: Array<{ __typename?: 'ExternalBookingProposalAttachment', id: number, originalFilename: string | null, downloadUrl: string | null }> };

export type BookingQuotationQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type BookingQuotationQuery = { __typename?: 'RootQueryType', bookingQuotation: { __typename?: 'ExternalBookingQuotation', id: number, reference: string | null, status: BookingQuotationExternalStatusEnum, closesAt: string | null, timezone: string, agentNotes: string | null, declined: boolean, declineReason: string | null, owner: { __typename?: 'ExternalBookingQuotationOwner', name: string, logoUrl: string | null }, invitedAgent: { __typename?: 'ExternalInvitedAgent', name: string }, shipment: { __typename?: 'ExternalShipment', shipmentType: ShipmentTypeEnum | null, maritimeTransportType: MaritimeTransportTypeEnum | null, cargoAttributes: Array<CargoAttributeEnum>, totalGrossWeight: string | null, totalNetWeight: string | null, pickupLocation: string | null, expectedSeparationAt: string | null, totalPallets: number, loadingPort: { __typename?: 'ExternalMaritimePort', id: number, name: string | null, unlocode: string | null } | null, dischargePort: { __typename?: 'ExternalMaritimePort', id: number, name: string | null, unlocode: string | null } | null, pallets: Array<{ __typename?: 'ExternalShipmentPallet', sizeType: PalletSizeTypeEnum, lengthMm: number | null, widthMm: number | null, isoCode: string | null, eurCode: string | null, quantity: number, heightCm: number | null }>, documents: Array<{ __typename?: 'ExternalDocument', id: number, type: DocumentTypeEnum | null, originalFilename: string | null, downloadUrl: string | null }> }, proposals: Array<{ __typename?: 'ExternalBookingProposal', id: number, number: string, status: BookingProposalStatusEnum, serviceType: BookingProposalServiceTypeEnum | null, transitTimeDays: number | null, coLoader: string | null, routeNotes: string | null, originCosts: string | null, originFees: string | null, originDomesticFreight: string | null, internationalFreight: string | null, destinationCosts: string | null, destinationInlandFreight: string | null, total: string | null, conditions: string | null, withdrawnAt: string | null, insertedAt: string, updatedAt: string, sealine: { __typename?: 'ExternalSealine', id: number, name: string | null, nickname: string | null } | null, loadingPort: { __typename?: 'ExternalMaritimePort', id: number, name: string | null, unlocode: string | null } | null, dischargePort: { __typename?: 'ExternalMaritimePort', id: number, name: string | null, unlocode: string | null } | null, attachments: Array<{ __typename?: 'ExternalBookingProposalAttachment', id: number, originalFilename: string | null, downloadUrl: string | null }> }> } | null };

export type DeclineBookingQuotationMutationVariables = Exact<{
  token: Scalars['String']['input'];
  params?: InputMaybe<DeclineBookingQuotationParams>;
}>;


export type DeclineBookingQuotationMutation = { __typename?: 'RootMutationType', declineBookingQuotation: { __typename?: 'ExternalBookingQuotation', id: number, declined: boolean, declineReason: string | null } | null };

export type UpsertBookingProposalMutationVariables = Exact<{
  token: Scalars['String']['input'];
  params: UpsertBookingProposalParams;
}>;


export type UpsertBookingProposalMutation = { __typename?: 'RootMutationType', upsertBookingProposal: { __typename?: 'ExternalBookingProposal', id: number, number: string, status: BookingProposalStatusEnum, serviceType: BookingProposalServiceTypeEnum | null, transitTimeDays: number | null, coLoader: string | null, routeNotes: string | null, originCosts: string | null, originFees: string | null, originDomesticFreight: string | null, internationalFreight: string | null, destinationCosts: string | null, destinationInlandFreight: string | null, total: string | null, conditions: string | null, withdrawnAt: string | null, insertedAt: string, updatedAt: string, sealine: { __typename?: 'ExternalSealine', id: number, name: string | null, nickname: string | null } | null, loadingPort: { __typename?: 'ExternalMaritimePort', id: number, name: string | null, unlocode: string | null } | null, dischargePort: { __typename?: 'ExternalMaritimePort', id: number, name: string | null, unlocode: string | null } | null, attachments: Array<{ __typename?: 'ExternalBookingProposalAttachment', id: number, originalFilename: string | null, downloadUrl: string | null }> } | null };

export type WithdrawBookingProposalMutationVariables = Exact<{
  token: Scalars['String']['input'];
  id: Scalars['Int']['input'];
}>;


export type WithdrawBookingProposalMutation = { __typename?: 'RootMutationType', withdrawBookingProposal: { __typename?: 'ExternalBookingProposal', id: number, status: BookingProposalStatusEnum, withdrawnAt: string | null, updatedAt: string } | null };

export const ExternalMaritimeTransportShipmentFieldsFragmentDoc = gql`
    fragment ExternalMaritimeTransportShipmentFields on ExternalMaritimeTransportShipment {
  booking
}
    `;
export const ExternalInternationalFreightFieldsFragmentDoc = gql`
    fragment ExternalInternationalFreightFields on ExternalInternationalFreight {
  cargoAttributes
  pickupLocation
  expectedSeparationAt
  voyageNumber
  bookingEtd
  bookingEta
  sealine {
    id
    name
    nickname
  }
  vessel {
    id
    name
    imoNumber
  }
  bookingLoadingPort {
    id
    name
    unlocode
  }
  bookingDischargePort {
    id
    name
    unlocode
  }
}
    `;
export const ExternalForeignTradeShipmentFieldsFragmentDoc = gql`
    fragment ExternalForeignTradeShipmentFields on ExternalForeignTradeShipment {
  type
  totalGrossWeight
  totalNetWeight
  totalPallets
  pallets {
    sizeType
    lengthMm
    widthMm
    isoCode
    eurCode
    quantity
    heightCm
  }
  maritimeTransportShipment {
    ...ExternalMaritimeTransportShipmentFields
  }
  internationalFreight {
    ...ExternalInternationalFreightFields
  }
}
    ${ExternalMaritimeTransportShipmentFieldsFragmentDoc}
${ExternalInternationalFreightFieldsFragmentDoc}`;
export const ExternalProcessFieldsFragmentDoc = gql`
    fragment ExternalProcessFields on ExternalProcess {
  id
  referenceCode
  timezone
  owner {
    name
    logoUrl
  }
  documents {
    id
    type
    originalFilename
    downloadUrl
  }
  bookingQuotation {
    id
    agentNotes
    collectionNotes
    winnerProposalNumber
    invitedAgent {
      name
    }
  }
  foreignTradeShipment {
    ...ExternalForeignTradeShipmentFields
  }
}
    ${ExternalForeignTradeShipmentFieldsFragmentDoc}`;
export const ExternalBookingProposalFieldsFragmentDoc = gql`
    fragment ExternalBookingProposalFields on ExternalBookingProposal {
  id
  number
  status
  sealine {
    id
    name
    nickname
  }
  serviceType
  transitTimeDays
  coLoader
  loadingPort {
    id
    name
    unlocode
  }
  dischargePort {
    id
    name
    unlocode
  }
  routeNotes
  originCosts
  originFees
  originDomesticFreight
  internationalFreight
  destinationCosts
  destinationInlandFreight
  total
  conditions
  attachments {
    id
    originalFilename
    downloadUrl
  }
  withdrawnAt
  insertedAt
  updatedAt
}
    `;
export const InviteDocument = gql`
    query Invite($token: String!) {
  invite(token: $token) {
    status
    type
    email
    locale
    closesAt
    canceledAt
    sessionValid
  }
}
    `;

/**
 * __useInviteQuery__
 *
 * To run a query within a React component, call `useInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `useInviteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInviteQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useInviteQuery(baseOptions: Apollo.QueryHookOptions<InviteQuery, InviteQueryVariables> & ({ variables: InviteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InviteQuery, InviteQueryVariables>(InviteDocument, options);
      }
export function useInviteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InviteQuery, InviteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InviteQuery, InviteQueryVariables>(InviteDocument, options);
        }
// @ts-ignore
export function useInviteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InviteQuery, InviteQueryVariables>): Apollo.UseSuspenseQueryResult<InviteQuery, InviteQueryVariables>;
export function useInviteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InviteQuery, InviteQueryVariables>): Apollo.UseSuspenseQueryResult<InviteQuery | undefined, InviteQueryVariables>;
export function useInviteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InviteQuery, InviteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InviteQuery, InviteQueryVariables>(InviteDocument, options);
        }
export type InviteQueryHookResult = ReturnType<typeof useInviteQuery>;
export type InviteLazyQueryHookResult = ReturnType<typeof useInviteLazyQuery>;
export type InviteSuspenseQueryHookResult = ReturnType<typeof useInviteSuspenseQuery>;
export type InviteQueryResult = Apollo.QueryResult<InviteQuery, InviteQueryVariables>;
export const RequestOtpDocument = gql`
    mutation RequestOtp($token: String!) {
  requestOtp(token: $token)
}
    `;
export type RequestOtpMutationFn = Apollo.MutationFunction<RequestOtpMutation, RequestOtpMutationVariables>;

/**
 * __useRequestOtpMutation__
 *
 * To run a mutation, you first call `useRequestOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestOtpMutation, { data, loading, error }] = useRequestOtpMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useRequestOtpMutation(baseOptions?: Apollo.MutationHookOptions<RequestOtpMutation, RequestOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestOtpMutation, RequestOtpMutationVariables>(RequestOtpDocument, options);
      }
export type RequestOtpMutationHookResult = ReturnType<typeof useRequestOtpMutation>;
export type RequestOtpMutationResult = Apollo.MutationResult<RequestOtpMutation>;
export type RequestOtpMutationOptions = Apollo.BaseMutationOptions<RequestOtpMutation, RequestOtpMutationVariables>;
export const ValidateOtpDocument = gql`
    mutation ValidateOtp($token: String!, $code: String!) {
  validateOtp(token: $token, code: $code)
}
    `;
export type ValidateOtpMutationFn = Apollo.MutationFunction<ValidateOtpMutation, ValidateOtpMutationVariables>;

/**
 * __useValidateOtpMutation__
 *
 * To run a mutation, you first call `useValidateOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateOtpMutation, { data, loading, error }] = useValidateOtpMutation({
 *   variables: {
 *      token: // value for 'token'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useValidateOtpMutation(baseOptions?: Apollo.MutationHookOptions<ValidateOtpMutation, ValidateOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateOtpMutation, ValidateOtpMutationVariables>(ValidateOtpDocument, options);
      }
export type ValidateOtpMutationHookResult = ReturnType<typeof useValidateOtpMutation>;
export type ValidateOtpMutationResult = Apollo.MutationResult<ValidateOtpMutation>;
export type ValidateOtpMutationOptions = Apollo.BaseMutationOptions<ValidateOtpMutation, ValidateOtpMutationVariables>;
export const GetExternalMaritimePortsDocument = gql`
    query GetExternalMaritimePorts($search: String) {
  externalMaritimePorts(search: $search) {
    id
    name
    unlocode
  }
}
    `;

/**
 * __useGetExternalMaritimePortsQuery__
 *
 * To run a query within a React component, call `useGetExternalMaritimePortsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExternalMaritimePortsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExternalMaritimePortsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetExternalMaritimePortsQuery(baseOptions?: Apollo.QueryHookOptions<GetExternalMaritimePortsQuery, GetExternalMaritimePortsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExternalMaritimePortsQuery, GetExternalMaritimePortsQueryVariables>(GetExternalMaritimePortsDocument, options);
      }
export function useGetExternalMaritimePortsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExternalMaritimePortsQuery, GetExternalMaritimePortsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExternalMaritimePortsQuery, GetExternalMaritimePortsQueryVariables>(GetExternalMaritimePortsDocument, options);
        }
// @ts-ignore
export function useGetExternalMaritimePortsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetExternalMaritimePortsQuery, GetExternalMaritimePortsQueryVariables>): Apollo.UseSuspenseQueryResult<GetExternalMaritimePortsQuery, GetExternalMaritimePortsQueryVariables>;
export function useGetExternalMaritimePortsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExternalMaritimePortsQuery, GetExternalMaritimePortsQueryVariables>): Apollo.UseSuspenseQueryResult<GetExternalMaritimePortsQuery | undefined, GetExternalMaritimePortsQueryVariables>;
export function useGetExternalMaritimePortsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExternalMaritimePortsQuery, GetExternalMaritimePortsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExternalMaritimePortsQuery, GetExternalMaritimePortsQueryVariables>(GetExternalMaritimePortsDocument, options);
        }
export type GetExternalMaritimePortsQueryHookResult = ReturnType<typeof useGetExternalMaritimePortsQuery>;
export type GetExternalMaritimePortsLazyQueryHookResult = ReturnType<typeof useGetExternalMaritimePortsLazyQuery>;
export type GetExternalMaritimePortsSuspenseQueryHookResult = ReturnType<typeof useGetExternalMaritimePortsSuspenseQuery>;
export type GetExternalMaritimePortsQueryResult = Apollo.QueryResult<GetExternalMaritimePortsQuery, GetExternalMaritimePortsQueryVariables>;
export const GetExternalSealinesDocument = gql`
    query GetExternalSealines($search: String) {
  externalSealines(search: $search) {
    id
    name
    nickname
  }
}
    `;

/**
 * __useGetExternalSealinesQuery__
 *
 * To run a query within a React component, call `useGetExternalSealinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExternalSealinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExternalSealinesQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetExternalSealinesQuery(baseOptions?: Apollo.QueryHookOptions<GetExternalSealinesQuery, GetExternalSealinesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExternalSealinesQuery, GetExternalSealinesQueryVariables>(GetExternalSealinesDocument, options);
      }
export function useGetExternalSealinesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExternalSealinesQuery, GetExternalSealinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExternalSealinesQuery, GetExternalSealinesQueryVariables>(GetExternalSealinesDocument, options);
        }
// @ts-ignore
export function useGetExternalSealinesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetExternalSealinesQuery, GetExternalSealinesQueryVariables>): Apollo.UseSuspenseQueryResult<GetExternalSealinesQuery, GetExternalSealinesQueryVariables>;
export function useGetExternalSealinesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExternalSealinesQuery, GetExternalSealinesQueryVariables>): Apollo.UseSuspenseQueryResult<GetExternalSealinesQuery | undefined, GetExternalSealinesQueryVariables>;
export function useGetExternalSealinesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExternalSealinesQuery, GetExternalSealinesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExternalSealinesQuery, GetExternalSealinesQueryVariables>(GetExternalSealinesDocument, options);
        }
export type GetExternalSealinesQueryHookResult = ReturnType<typeof useGetExternalSealinesQuery>;
export type GetExternalSealinesLazyQueryHookResult = ReturnType<typeof useGetExternalSealinesLazyQuery>;
export type GetExternalSealinesSuspenseQueryHookResult = ReturnType<typeof useGetExternalSealinesSuspenseQuery>;
export type GetExternalSealinesQueryResult = Apollo.QueryResult<GetExternalSealinesQuery, GetExternalSealinesQueryVariables>;
export const GetExternalVesselsDocument = gql`
    query GetExternalVessels($search: String) {
  externalVessels(search: $search) {
    id
    name
    imoNumber
  }
}
    `;

/**
 * __useGetExternalVesselsQuery__
 *
 * To run a query within a React component, call `useGetExternalVesselsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExternalVesselsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExternalVesselsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetExternalVesselsQuery(baseOptions?: Apollo.QueryHookOptions<GetExternalVesselsQuery, GetExternalVesselsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExternalVesselsQuery, GetExternalVesselsQueryVariables>(GetExternalVesselsDocument, options);
      }
export function useGetExternalVesselsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExternalVesselsQuery, GetExternalVesselsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExternalVesselsQuery, GetExternalVesselsQueryVariables>(GetExternalVesselsDocument, options);
        }
// @ts-ignore
export function useGetExternalVesselsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetExternalVesselsQuery, GetExternalVesselsQueryVariables>): Apollo.UseSuspenseQueryResult<GetExternalVesselsQuery, GetExternalVesselsQueryVariables>;
export function useGetExternalVesselsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExternalVesselsQuery, GetExternalVesselsQueryVariables>): Apollo.UseSuspenseQueryResult<GetExternalVesselsQuery | undefined, GetExternalVesselsQueryVariables>;
export function useGetExternalVesselsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExternalVesselsQuery, GetExternalVesselsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExternalVesselsQuery, GetExternalVesselsQueryVariables>(GetExternalVesselsDocument, options);
        }
export type GetExternalVesselsQueryHookResult = ReturnType<typeof useGetExternalVesselsQuery>;
export type GetExternalVesselsLazyQueryHookResult = ReturnType<typeof useGetExternalVesselsLazyQuery>;
export type GetExternalVesselsSuspenseQueryHookResult = ReturnType<typeof useGetExternalVesselsSuspenseQuery>;
export type GetExternalVesselsQueryResult = Apollo.QueryResult<GetExternalVesselsQuery, GetExternalVesselsQueryVariables>;
export const GetExternalProcessDocument = gql`
    query GetExternalProcess($token: String!) {
  externalProcess(token: $token) {
    ...ExternalProcessFields
  }
}
    ${ExternalProcessFieldsFragmentDoc}`;

/**
 * __useGetExternalProcessQuery__
 *
 * To run a query within a React component, call `useGetExternalProcessQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExternalProcessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExternalProcessQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetExternalProcessQuery(baseOptions: Apollo.QueryHookOptions<GetExternalProcessQuery, GetExternalProcessQueryVariables> & ({ variables: GetExternalProcessQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExternalProcessQuery, GetExternalProcessQueryVariables>(GetExternalProcessDocument, options);
      }
export function useGetExternalProcessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExternalProcessQuery, GetExternalProcessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExternalProcessQuery, GetExternalProcessQueryVariables>(GetExternalProcessDocument, options);
        }
// @ts-ignore
export function useGetExternalProcessSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetExternalProcessQuery, GetExternalProcessQueryVariables>): Apollo.UseSuspenseQueryResult<GetExternalProcessQuery, GetExternalProcessQueryVariables>;
export function useGetExternalProcessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExternalProcessQuery, GetExternalProcessQueryVariables>): Apollo.UseSuspenseQueryResult<GetExternalProcessQuery | undefined, GetExternalProcessQueryVariables>;
export function useGetExternalProcessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExternalProcessQuery, GetExternalProcessQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExternalProcessQuery, GetExternalProcessQueryVariables>(GetExternalProcessDocument, options);
        }
export type GetExternalProcessQueryHookResult = ReturnType<typeof useGetExternalProcessQuery>;
export type GetExternalProcessLazyQueryHookResult = ReturnType<typeof useGetExternalProcessLazyQuery>;
export type GetExternalProcessSuspenseQueryHookResult = ReturnType<typeof useGetExternalProcessSuspenseQuery>;
export type GetExternalProcessQueryResult = Apollo.QueryResult<GetExternalProcessQuery, GetExternalProcessQueryVariables>;
export const SubmitBookingDataDocument = gql`
    mutation SubmitBookingData($token: String!, $params: SubmitBookingDataParams!) {
  submitBookingData(token: $token, params: $params) {
    ...ExternalProcessFields
  }
}
    ${ExternalProcessFieldsFragmentDoc}`;
export type SubmitBookingDataMutationFn = Apollo.MutationFunction<SubmitBookingDataMutation, SubmitBookingDataMutationVariables>;

/**
 * __useSubmitBookingDataMutation__
 *
 * To run a mutation, you first call `useSubmitBookingDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitBookingDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitBookingDataMutation, { data, loading, error }] = useSubmitBookingDataMutation({
 *   variables: {
 *      token: // value for 'token'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useSubmitBookingDataMutation(baseOptions?: Apollo.MutationHookOptions<SubmitBookingDataMutation, SubmitBookingDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitBookingDataMutation, SubmitBookingDataMutationVariables>(SubmitBookingDataDocument, options);
      }
export type SubmitBookingDataMutationHookResult = ReturnType<typeof useSubmitBookingDataMutation>;
export type SubmitBookingDataMutationResult = Apollo.MutationResult<SubmitBookingDataMutation>;
export type SubmitBookingDataMutationOptions = Apollo.BaseMutationOptions<SubmitBookingDataMutation, SubmitBookingDataMutationVariables>;
export const BookingQuotationDocument = gql`
    query BookingQuotation($token: String!) {
  bookingQuotation(token: $token) {
    id
    reference
    status
    closesAt
    timezone
    agentNotes
    declined
    declineReason
    owner {
      name
      logoUrl
    }
    invitedAgent {
      name
    }
    shipment {
      shipmentType
      maritimeTransportType
      cargoAttributes
      totalGrossWeight
      totalNetWeight
      loadingPort {
        id
        name
        unlocode
      }
      dischargePort {
        id
        name
        unlocode
      }
      pickupLocation
      expectedSeparationAt
      totalPallets
      pallets {
        sizeType
        lengthMm
        widthMm
        isoCode
        eurCode
        quantity
        heightCm
      }
      documents {
        id
        type
        originalFilename
        downloadUrl
      }
    }
    proposals {
      ...ExternalBookingProposalFields
    }
  }
}
    ${ExternalBookingProposalFieldsFragmentDoc}`;

/**
 * __useBookingQuotationQuery__
 *
 * To run a query within a React component, call `useBookingQuotationQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingQuotationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingQuotationQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useBookingQuotationQuery(baseOptions: Apollo.QueryHookOptions<BookingQuotationQuery, BookingQuotationQueryVariables> & ({ variables: BookingQuotationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingQuotationQuery, BookingQuotationQueryVariables>(BookingQuotationDocument, options);
      }
export function useBookingQuotationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingQuotationQuery, BookingQuotationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingQuotationQuery, BookingQuotationQueryVariables>(BookingQuotationDocument, options);
        }
// @ts-ignore
export function useBookingQuotationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BookingQuotationQuery, BookingQuotationQueryVariables>): Apollo.UseSuspenseQueryResult<BookingQuotationQuery, BookingQuotationQueryVariables>;
export function useBookingQuotationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookingQuotationQuery, BookingQuotationQueryVariables>): Apollo.UseSuspenseQueryResult<BookingQuotationQuery | undefined, BookingQuotationQueryVariables>;
export function useBookingQuotationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookingQuotationQuery, BookingQuotationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookingQuotationQuery, BookingQuotationQueryVariables>(BookingQuotationDocument, options);
        }
export type BookingQuotationQueryHookResult = ReturnType<typeof useBookingQuotationQuery>;
export type BookingQuotationLazyQueryHookResult = ReturnType<typeof useBookingQuotationLazyQuery>;
export type BookingQuotationSuspenseQueryHookResult = ReturnType<typeof useBookingQuotationSuspenseQuery>;
export type BookingQuotationQueryResult = Apollo.QueryResult<BookingQuotationQuery, BookingQuotationQueryVariables>;
export const DeclineBookingQuotationDocument = gql`
    mutation DeclineBookingQuotation($token: String!, $params: DeclineBookingQuotationParams) {
  declineBookingQuotation(token: $token, params: $params) {
    id
    declined
    declineReason
  }
}
    `;
export type DeclineBookingQuotationMutationFn = Apollo.MutationFunction<DeclineBookingQuotationMutation, DeclineBookingQuotationMutationVariables>;

/**
 * __useDeclineBookingQuotationMutation__
 *
 * To run a mutation, you first call `useDeclineBookingQuotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineBookingQuotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineBookingQuotationMutation, { data, loading, error }] = useDeclineBookingQuotationMutation({
 *   variables: {
 *      token: // value for 'token'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useDeclineBookingQuotationMutation(baseOptions?: Apollo.MutationHookOptions<DeclineBookingQuotationMutation, DeclineBookingQuotationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeclineBookingQuotationMutation, DeclineBookingQuotationMutationVariables>(DeclineBookingQuotationDocument, options);
      }
export type DeclineBookingQuotationMutationHookResult = ReturnType<typeof useDeclineBookingQuotationMutation>;
export type DeclineBookingQuotationMutationResult = Apollo.MutationResult<DeclineBookingQuotationMutation>;
export type DeclineBookingQuotationMutationOptions = Apollo.BaseMutationOptions<DeclineBookingQuotationMutation, DeclineBookingQuotationMutationVariables>;
export const UpsertBookingProposalDocument = gql`
    mutation UpsertBookingProposal($token: String!, $params: UpsertBookingProposalParams!) {
  upsertBookingProposal(token: $token, params: $params) {
    ...ExternalBookingProposalFields
  }
}
    ${ExternalBookingProposalFieldsFragmentDoc}`;
export type UpsertBookingProposalMutationFn = Apollo.MutationFunction<UpsertBookingProposalMutation, UpsertBookingProposalMutationVariables>;

/**
 * __useUpsertBookingProposalMutation__
 *
 * To run a mutation, you first call `useUpsertBookingProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertBookingProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertBookingProposalMutation, { data, loading, error }] = useUpsertBookingProposalMutation({
 *   variables: {
 *      token: // value for 'token'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUpsertBookingProposalMutation(baseOptions?: Apollo.MutationHookOptions<UpsertBookingProposalMutation, UpsertBookingProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertBookingProposalMutation, UpsertBookingProposalMutationVariables>(UpsertBookingProposalDocument, options);
      }
export type UpsertBookingProposalMutationHookResult = ReturnType<typeof useUpsertBookingProposalMutation>;
export type UpsertBookingProposalMutationResult = Apollo.MutationResult<UpsertBookingProposalMutation>;
export type UpsertBookingProposalMutationOptions = Apollo.BaseMutationOptions<UpsertBookingProposalMutation, UpsertBookingProposalMutationVariables>;
export const WithdrawBookingProposalDocument = gql`
    mutation WithdrawBookingProposal($token: String!, $id: Int!) {
  withdrawBookingProposal(token: $token, id: $id) {
    id
    status
    withdrawnAt
    updatedAt
  }
}
    `;
export type WithdrawBookingProposalMutationFn = Apollo.MutationFunction<WithdrawBookingProposalMutation, WithdrawBookingProposalMutationVariables>;

/**
 * __useWithdrawBookingProposalMutation__
 *
 * To run a mutation, you first call `useWithdrawBookingProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWithdrawBookingProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [withdrawBookingProposalMutation, { data, loading, error }] = useWithdrawBookingProposalMutation({
 *   variables: {
 *      token: // value for 'token'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWithdrawBookingProposalMutation(baseOptions?: Apollo.MutationHookOptions<WithdrawBookingProposalMutation, WithdrawBookingProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WithdrawBookingProposalMutation, WithdrawBookingProposalMutationVariables>(WithdrawBookingProposalDocument, options);
      }
export type WithdrawBookingProposalMutationHookResult = ReturnType<typeof useWithdrawBookingProposalMutation>;
export type WithdrawBookingProposalMutationResult = Apollo.MutationResult<WithdrawBookingProposalMutation>;
export type WithdrawBookingProposalMutationOptions = Apollo.BaseMutationOptions<WithdrawBookingProposalMutation, WithdrawBookingProposalMutationVariables>;